import {
  CategoryScale,
  Chart,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  Plugin,
  PointElement,
  Tooltip,
} from "chart.js";

// Register necessary Chart.js components\
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  Filler,
);

export const MyHrPayrollLineChartPlugin: Plugin<"line"> = {
  id: "customLabels",
  afterDatasetsDraw(chart: Chart<"line">): void {
    const { ctx } = chart;
    chart.data.datasets.forEach((dataset, i) => {
      const meta = chart.getDatasetMeta(i);
      if (!meta.hidden) {
        meta.data.forEach((element, index) => {
          // Set up text style
          ctx.fillStyle = "#fff";
          ctx.font = "10px Mulish, Roboto, Helvetica Neue, Arial, sans-serif";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";

          const value = dataset.data[index] as number;
          const dataString = new Intl.NumberFormat("hu").format(value);

          // Get tooltip position for drawing
          const { x, y } = element.tooltipPosition(true);

          // Skip if coordinates are null
          if (x === null || y === null) return;

          // Draw background circle
          ctx.beginPath();
          ctx.arc(x, y, 6, 0, 2 * Math.PI);
          ctx.fillStyle = "#cc0033";
          ctx.fill();

          // Draw border
          ctx.lineWidth = 3;
          ctx.strokeStyle = "#fff";
          ctx.stroke();

          // Draw dashed line and value text if positive
          if (value > 0) {
            const padding = 8;
            const startY = 24;

            ctx.fillStyle = "#fff";
            ctx.fillText(dataString, x, startY);

            ctx.save();
            ctx.beginPath();
            ctx.lineWidth = 1;
            ctx.setLineDash([5, 3]);
            ctx.moveTo(x, startY + padding);
            ctx.lineTo(x, y - padding);
            ctx.strokeStyle = "#fff";
            ctx.stroke();
            ctx.restore();
          }
        });
      }
    });
  },
};

export default MyHrPayrollLineChartPlugin;
